// // import logo from './logo.svg';
// // import './App.css';
// // import VayuLungCareWebsite from './Home';

// // function App() {
// //   return (
// //   <VayuLungCareWebsite />
// //   );
// // }

// // export default App;


// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import './App.css';

// // Import your components
// import VayuLungCareWebsite from './Home';
// import ServicesPage from './Pages/servicePage';
// import ServiceDetailPage from './Pages/servicespageDetails';
// import ProceduresPage from './Pages/procedures';
// import ContactPage from './Pages/contactPage';
// import ProcedureDetailPageRedesigned from './Pages/proceduresDetails';
// import DoctorDetailPage from './Pages/doctorsdetail';
// import ScrollToTop from './scrolltop';

// function App() {
//   return (
//     <Router>
//        <ScrollToTop />
       
//       <Routes>
//         {/* Home Page - Your existing component */}
//         <Route path="/" element={<VayuLungCareWebsite />} />
        
//         {/* Services Pages */}
//         <Route path="/services" element={<ServicesPage />} />
//         <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
        
//         {/* Procedures Page */}
//         <Route path="/procedures" element={<ProceduresPage />} />
//         <Route path="/procedures/:procedureId" element={<ProcedureDetailPageRedesigned />} />

//          <Route path="/doctors/:doctorId" element={<DoctorDetailPage />} />
        
//         {/* Contact Page */}
//         <Route path="/contact" element={<ContactPage />} />
        
//         {/* 404 Page */}
//         <Route path="*" element={
//           <div style={{
//             padding: '4rem 2rem', 
//             textAlign: 'center',
//             minHeight: '100vh',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             justifyContent: 'center'
//           }}>
//             <h1 style={{fontSize: '3rem', color: '#1B4965', marginBottom: '1rem'}}>404</h1>
//             <p style={{fontSize: '1.2rem', color: '#666', marginBottom: '2rem'}}>Page Not Found</p>
//             <a 
//               href="/" 
//               style={{
//                 padding: '1rem 2rem',
//                 background: 'linear-gradient(135deg, #E86A33, #FF9B6E)',
//                 color: 'white',
//                 textDecoration: 'none',
//                 borderRadius: '50px',
//                 fontWeight: '600'
//               }}
//             >
//               Go Home
//             </a>
//           </div>
//         } />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Import your components
import Header from './header';
import Footer from './footer'; 
import VayuLungCareWebsite from './Home';
import ServicesPage from './Pages/servicePage';
import ServiceDetailPage from './Pages/servicespageDetails';
import ProceduresPage from './Pages/procedures';
import ContactPage from './Pages/contactPage';
import ProcedureDetailPageRedesigned from './Pages/proceduresDetails';
import DoctorDetailPage from './Pages/doctorsdetail';
import ScrollToTop from './scrolltop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app-wrapper">
        <Header />
        
        <main className="main-content">
          <Routes>
            {/* Home Page - Your existing component */}
            <Route path="/" element={<VayuLungCareWebsite />} />
            
            {/* Services Pages */}
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            
            {/* Procedures Page */}
            <Route path="/procedures" element={<ProceduresPage />} />
            <Route path="/procedures/:procedureId" element={<ProcedureDetailPageRedesigned />} />

            <Route path="/doctors/:doctorId" element={<DoctorDetailPage />} />
            
            {/* Contact Page */}
            <Route path="/contact" element={<ContactPage />} />
            
            {/* 404 Page */}
            <Route path="*" element={
              <div style={{
                padding: '4rem 2rem', 
                textAlign: 'center',
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <h1 style={{fontSize: '3rem', color: '#1B4965', marginBottom: '1rem'}}>404</h1>
                <p style={{fontSize: '1.2rem', color: '#666', marginBottom: '2rem'}}>Page Not Found</p>
                <a 
                  href="/" 
                  style={{
                    padding: '1rem 2rem',
                    background: 'linear-gradient(135deg, #E86A33, #FF9B6E)',
                    color: 'white',
                    textDecoration: 'none',
                    borderRadius: '50px',
                    fontWeight: '600'
                }}
                >
                  Go Home
                </a>
              </div>
            } />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
